// Modules
import { useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import { Toaster, toast } from "react-hot-toast";
import { motion } from "framer-motion";
import Multiselect from "multiselect-react-dropdown";
import { AuthContext } from "../../../../Context/AuthContext";
// Services
import { register } from "../../../../Services/usersService";
// Components
import Input from "../../../Common/Input/Input";
// Styles
import Styles from "./Styles/Register.module.css";
// Images
import logoImage from "../../../../Assets/Images/logo.png";
import closeImage from "../../../../Assets/Icons/close.png";

const Register = () => {
  const { isLoggedIn, login } = useContext(AuthContext);
  const history = useHistory();
  if (isLoggedIn) {
    history.replace("/");
    toast.error("!شما قبلا وارد شده اید");
  }
  const [account, setAccount] = useState({
    email: "",
    phoneNumber: "",
    fullname: "",
    education: "diploma",
    Academic: "diploma",
    password: "",
    confirmPassword: "",
    assist: false,
    interestAreas: [],
  });

  const [selectedData, setSelectedData] = useState([]);

  const data = [
    { area: "آموزش پیش دبستانی و دبستانی" },
    { area: "مدیریت و برنامه ریزی آموزشی" },
    { area: "برنامه ریزی آموزشی" },
    { area: "آموزش و پرورش تطبیقی" },
    { area: "برنامه ریزی درسی" },
    { area: "تحقیقات آموزشی" },
    { area: "آموزش و پرورش استثنایی" },
    { area: "روانشناسی تربیتی" },
    { area: "آموزش بزرگسالان" },
    { area: "مشاوره و راهنمایی" },
    { area: "آموزش و بهسازی منابع انسانی" },
    { area: "تاریخ و فلسفه تعلیم و تربیت" },
    { area: "تکنولوژی آموزشی" },
    { area: "مدیریت و برنامه ریزی آموزش عالی" },
    { area: "سنجش و اندازه گیری در آموزش و پرورش" },
    { area: "برنامه ریزی توسعه آموزش عالی" },
    { area: "برنامه ریزی درسی در آموزش عالی" },
    { area: "مدیریت آموزش عالی" },
    { area: "اقتصاد آموزش عالی" },
    { area: "یادگیری مادام العمر" },
    { area: "تئوری های یادگیری" },
    { area: "طراحی ابزار و ملزومات کمک آموزشی" },
    { area: "کسب و کار آموزشی" },
    { area: "اقتصاد آموزش و پرورش" },
    { area: "جریان پژوهی آموزشی و تربیتی" },
    { area: "آموزش عصب شناختی" },
    { area: "تجربه کاوی مدارس پیشرو و برتر" },
    { area: "سیاست گذاری آموزشی" },
    { area: "طراحی فضاهای یادگیری" },
    { area: "بهسازی زیست آموزشی " },
    { area: "سرگرمی پژوهی و بازی وارسازی" },
    { area: "پژوهش های اماری و کمی" },
    { area: "فلسفه ذهن" },
    { area: "مدل سازی شناختی" },
    { area: "زبان شناختی" },
    { area: "علوم اعصاب شناختی" },
    { area: "روان شناسی اختلالات یادگیری" },
    { area: "روانشناسی بالینی" },
    { area: "روانشناسی رشد و شناخت" },
    { area: "آگاهی پژوهی" },
    { area: "کتاب کودک و نوجوان" },
    { area: "الگو های مدرسه داری" },
    { area: "جامعه شناسی آموزش و پرورش" },
    { area: "پداگوژی" },
    { area: "تعلیم و تربیت باستان" },
    { area: "روش های تدریس" },
    { area: "اندیشمند پژوهی" },
    { area: "حکمرانی آموزشی" },
    { area: "منبع پژوهی آموزشی و تربیتی" },
    { area: "نظام های آموزشی" },
    { area: "فراشناخت کاربردی" },
    { area: "مفاهیم و نظریات آموزشی " },
    { area: "نهاد و سازمان پژوهی" },
    { area: "عدالت آموزشی" },
    { area: "فلسفه برای کودکان" },
  ];

  const [options] = useState(data);

  const ValidationSchema = Yup.object().shape({
    email: Yup.string()
      .required("لطفا ایمیل یا شماره تماس خود را وارد کنید")
      .email("فرمت ایمیل صحیح نیست"),
    // phoneNumber: Yup.string()
    //   .matches(/^09\d{9}$/, "لطفا شماره تلفن را با فرمت 09 وارد کنید")
    //   .nullable(),
    fullname: Yup.string().required("لطفا نام و نام خانوادگی را وارد کنید"),
    education: Yup.string()
      .required("لطفا سطح تحصیلات خود را انتخاب کنید")
      .oneOf(
        ["diploma", "associate", "masters", "senior", "phd"],
        "لطفا سطح تحصیلات را از موارد موجود انتخاب کنید"
      ),
    // Academic: Yup.string()
    //   .required("لطفا رشته دانشگاهی خود را انتخاب کنید")
    //   .oneOf(
    //     ["diploma", "associate", "masters", "senior", "phd"],
    //     "لطفا رشته دانشگاهی خود را از موارد موجود انتخاب کنید"
    //   ),
    password: Yup.string()
      .required("لطفا رمز عبور خود را وارد کنید")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
        "رمز عبور باید حداقل ۸ کاراکتر شامل حروف و اعداد باشد"
      ),
    confirmPassword: Yup.string()
      .required("لطفا تکرار رمز عبور را وارد کنید")
      .oneOf(
        [Yup.ref("password"), null],
        "تکرار رمز عبور با رمز عبور یکسان نیست"
      ),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await ValidationSchema.validate(account, {
        abortEarly: false,
      });
      const userInfo = { ...account };
      userInfo.interestAreas = selectedData;
      toast.promise(register(userInfo), {
        loading: "در حال ارسال اطلاعات . . .",
        success: (res) => {
          login(res.data.token);
          history.replace("/");
          window.location.reload();
          return "کاربر با موفقیت ساخته شد";
        },
        error: (e) => e.response.data.message,
      });
    } catch (ex) {
      ex.errors.map((i) => toast.error(i));
    }
  };

  const handleChange = ({ target: input }) => {
    const copyAccount = { ...account };
    copyAccount[input.name] = input.value;
    setAccount(copyAccount);
  };

  const handleAssist = (e) => {
    const newAccount = { ...account };
    newAccount.assist = e.target.checked;
    setAccount(newAccount);
  };

  return (
    <div className={Styles.container}>
      <Toaster
        toastOptions={{
          duration: 2000,
          style: {
            background: "#363636",
            color: "#fff",
          },
        }}
      />
      <motion.div
        initial={{ x: 1000 }}
        animate={{ x: 0 }}
        exit={{ x: 1000 }}
        transition={{ duration: 0.8 }}
        className={Styles.logoContainer}
      >
        <img src={logoImage} alt="" />
      </motion.div>
      <motion.div
        initial={{ x: -1000 }}
        animate={{ x: 0 }}
        exit={{ x: -1000 }}
        transition={{ duration: 0.8 }}
        className={Styles.RegisterContainer}
      >
        <div className={Styles.flexContainer}>
          <Link to="/" className={Styles.closePage}>
            <img src={closeImage} alt="" />
          </Link>
          <form onSubmit={handleSubmit} className={Styles.innerContainer}>
            <h2>ثبت نام</h2>
            <div className={Styles.register}>
              <Link to="/users/login">حساب کاربری دارم</Link>
            </div>
            <div className={Styles.inputContainer}>
              <div className={Styles.rowInputs}>
                <div className={Styles.input}>
                  <Input
                    name="email"
                    handleChange={handleChange}
                    value={account.email}
                    autoFocus={true}
                    placeholder="*ایمیل"
                    type="email"
                  />
                </div>
                <div className={Styles.input}>
                  <Input
                    name="phoneNumber"
                    handleChange={handleChange}
                    value={account.phoneNumber}
                    autoFocus={false}
                    placeholder="شماره تماس"
                    type="text"
                  />
                </div>
              </div>
              <div className={Styles.input}>
                <Input
                  name="fullname"
                  handleChange={handleChange}
                  value={account.fullname}
                  autoFocus={false}
                  placeholder="*نام و نام خانوادگی"
                  type="text"
                />
              </div>
              {/* <div className={Styles.selectOptionsContainer}> */}
              <div className={Styles.selectOptions}>
                <label htmlFor="education">سطح تحصیلات</label>
                <select name="education" id="education" onChange={handleChange}>
                  <option value="high school">زیر دیپلم</option>
                  <option value="diploma">دیپلم</option>
                  <option value="associate">کاردانی</option>
                  <option value="masters">کارشناسی</option>
                  <option value="senior">کارشناسی ارشد</option>
                  <option value="phd">دکتری</option>
                </select>
              </div>
              {/* <div className={Styles.selectOptions}> */}
              {/* <label htmlFor="Academic">رشته دانشگاهی</label>
                  <select name="Academic" id="Academic" onChange={handleChange}>
                    <option value="diploma">دیپلم</option>
                    <option value="associate">کاردانی</option>
                    <option value="masters">کارشناسی</option>
                    <option value="senior">کارشناسی ارشد</option>
                    <option value="phd">دکتری</option>
                  </select> */}
              {/* </div> */}
              {/* </div> */}
              <div className={Styles.input}>
                <Multiselect
                  selectionLimit={5}
                  options={options}
                  displayValue="area"
                  closeIcon="circle"
                  placeholder="علاقه مندی"
                  className={Styles.multiSelect}
                  onSelect={(val) => setSelectedData(val)}
                  onRemove={(val) => setSelectedData(val)}
                  selectedValues={selectedData}
                  style={{
                    chips: { background: "#4b495b" },
                    searchBox: {
                      background: "#ACABB4",
                      border: "none",
                      direction: "rtl",
                    },
                  }}
                />
              </div>
              <div className={Styles.input}>
                <Input
                  name="password"
                  handleChange={handleChange}
                  value={account.password}
                  autoFocus={false}
                  placeholder="*رمز عبور"
                  type="password"
                />
              </div>
              <div className={Styles.input}>
                <Input
                  name="confirmPassword"
                  handleChange={handleChange}
                  value={account.confirmPassword}
                  autoFocus={false}
                  placeholder="*تکرار رمز عبور"
                  type="password"
                />
              </div>
              <div className={Styles.assistContainer}>
                <h3>تمایل دارم با مجموعه هرمه همکاری کنم</h3>
                <input
                  type="checkbox"
                  name="assist"
                  value={account.assist}
                  onChange={handleAssist}
                />
              </div>
              <div className={Styles.button}>
                <button className={Styles.submit} type="submit">
                  ثبت
                </button>
              </div>
            </div>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default Register;
